
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/asigurari-rca",
      function () {
        return require("private-next-pages/asigurari-rca/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/asigurari-rca"])
      });
    }
  